import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { FloatingTooltip } from '../../../Floating'
import { TableCellBase, TableEmptyCell } from '../../../Table'

import * as styles from './RequestProfileTabActivitiesTableManagerCell.module.css'

function RequestProfileTabActivitiesTableManagerCell({ item, ...restProps }) {
  const { manager } = item

  return manager ? (
    <TableCellBase {...restProps} className={styles.cell}>
      <FloatingTooltip content={manager.fullname}>
        <Avatar
          color={manager.avatar_color}
          size={AVATAR_HEIGHT_24}
          src={manager.avatar}
          text={manager.fullname}
        />
      </FloatingTooltip>
    </TableCellBase>
  ) : (
    <TableEmptyCell {...restProps} />
  )
}

export default RequestProfileTabActivitiesTableManagerCell
